import { render, staticRenderFns } from "./LetterPage.vue?vue&type=template&id=425217ef&"
import script from "./LetterPage.vue?vue&type=script&lang=js&"
export * from "./LetterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports